import { usePage, useWebsiteSettings } from 'client/store'
import { pageSelectors } from 'client/store/page/pageSelectors'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export const useCalculateHeadingFontWeight = ({
  fontWeight,
  mobileFontWeight,
}: {
  fontWeight?: string
  mobileFontWeight?: string
}) => {
  const pageGlobalFontWeight = usePage(
    pageSelectors.getGlobalFontProperties,
  ).headingFontWeight

  const {
    fontWeight: websiteGlobalFontWeight,
    mobileFontWeight: globalMobileFontWeight,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const globalFontWeight = pageGlobalFontWeight || websiteGlobalFontWeight

  return {
    calculatedFontWeight: getCalculatedProperty({
      desktopProperty: fontWeight,
      mobileProperty: mobileFontWeight,
      globalDesktopProperty: globalFontWeight,
      globalMobileProperty: globalMobileFontWeight,
    }),
    globalFontWeight,
    globalMobileFontWeight: globalMobileFontWeight || globalFontWeight,
  }
}
